export default "__VITE_ASSET__DaFaHm3$__"